import React from "react";
import ReactDOM from "react-dom/client";
/* PÍSMO (30. 9. 2026) — hostované LOKÁLNĚ, žádné Google Fonts (GDPR).
 * Inter Variable (osy wght + opsz) = jediná rodina CRM, tokeny --font-body /
 * --font-display v index.css. Playfair Display Variable = jen --font-editorial
 * (veřejný web poradce, leadgen, vizitka a volitelné styly „Editorial").
 * @font-face se stahuje líně: soubor přijde, až ho něco na stránce použije,
 * a jen ta abeceda, která na stránce je (latin, latin-ext, cyrilice, vi). */
import "@fontsource-variable/inter/opsz.css";
import "@fontsource-variable/inter/opsz-italic.css";
import "@fontsource-variable/playfair-display/wght.css";
import "@fontsource-variable/playfair-display/wght-italic.css";
import "@/index.css";
import "@/styles/apple-skin.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
